import { useState } from "react";
import { toast } from "sonner";
import axios from "axios";
import { Mail, MapPin, Send } from "lucide-react";
import { useSEO } from "@/lib/useSEO";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  useSEO({ title: "Contacto | Ruta Inteligente", description: "Ponte en contacto con el equipo de Ruta Inteligente." });
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email.includes("@") || form.message.trim().length < 5) {
      toast.error("Completa todos los campos correctamente.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/contact`, form);
      toast.success(data.message || "Mensaje enviado.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch {
      toast.error("No se pudo enviar el mensaje. Inténtalo más tarde.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-brand-terra mb-3">Contacto</p>
          <h1 className="font-heading text-4xl sm:text-5xl font-semibold text-brand-ink">Hablemos de viajes</h1>
          <p className="text-brand-sub mt-4 text-lg leading-relaxed">
            ¿Tienes una duda, una propuesta de colaboración o quieres que cubramos un destino?
            Escríbenos y te responderemos lo antes posible.
          </p>
          <div className="mt-8 space-y-4">
            <div className="flex items-center gap-3 text-brand-ink">
              <span className="w-10 h-10 rounded-full bg-brand-adbg flex items-center justify-center text-brand-terra"><Mail size={18} /></span>
              hola@rutainteligente.com
            </div>
            <div className="flex items-center gap-3 text-brand-ink">
              <span className="w-10 h-10 rounded-full bg-brand-adbg flex items-center justify-center text-brand-terra"><MapPin size={18} /></span>
              Madrid, España
            </div>
          </div>
        </div>

        <form onSubmit={submit} className="bg-brand-surface border border-brand-line rounded-lg p-6 sm:p-8 space-y-4">
          <div>
            <label className="text-sm font-medium text-brand-ink">Nombre</label>
            <input data-testid="contact-name" value={form.name} onChange={set("name")} className="w-full mt-1 px-4 py-3 rounded-sm border border-brand-line outline-none focus:ring-2 focus:ring-brand-terra" />
          </div>
          <div>
            <label className="text-sm font-medium text-brand-ink">Email</label>
            <input data-testid="contact-email" type="email" value={form.email} onChange={set("email")} className="w-full mt-1 px-4 py-3 rounded-sm border border-brand-line outline-none focus:ring-2 focus:ring-brand-terra" />
          </div>
          <div>
            <label className="text-sm font-medium text-brand-ink">Asunto</label>
            <input data-testid="contact-subject" value={form.subject} onChange={set("subject")} className="w-full mt-1 px-4 py-3 rounded-sm border border-brand-line outline-none focus:ring-2 focus:ring-brand-terra" />
          </div>
          <div>
            <label className="text-sm font-medium text-brand-ink">Mensaje</label>
            <textarea data-testid="contact-message" rows={5} value={form.message} onChange={set("message")} className="w-full mt-1 px-4 py-3 rounded-sm border border-brand-line outline-none focus:ring-2 focus:ring-brand-terra resize-none" />
          </div>
          <button data-testid="contact-submit" disabled={loading} className="w-full bg-brand-terra hover:bg-brand-terraDark text-white font-semibold px-6 py-3 rounded-sm transition-all hover:-translate-y-0.5 flex items-center justify-center gap-2 disabled:opacity-60">
            {loading ? "Enviando…" : "Enviar mensaje"} <Send size={16} />
          </button>
        </form>
      </div>
    </div>
  );
}
